import React, { useMemo } from "react";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import ReactFormat from "react-number-format";
import useActions from "./use-actions";
import SelectableOption, {
  SelectableOptionGroup,
} from "@dhn/components/molecules/selectable-option";
import UnsavedChangesModal from "@dhn/components/molecules/unsaved-changes-modal";
import ModalHeader from "@dhn/components/molecules/modal-header";
import LoadingDhn from "../../../../../../../../@dhn/components/Loading/LoadingDhn";
import User from "./InternalComponents/User";
import Medical from "./InternalComponents/Medical";
import { filterProfilesByRecipeCapability } from "../../../../../utils/profile-options";

export default function ModalAddAndEditUser(props) {
  const {
    onChange,
    optionProfiles,
    dataUserSelected,
    toggle,
    isOpen,
    isNew,
    isMedical,
    medicalSelected,
    profileSelected,
    schedulingFormat,
    scheduleSelected,
  } = props;

  const { state, actions } = useActions({
    ...props,
    userSelected: dataUserSelected,
    branchOfficeId: props.branchSelected?.id,
    isNewUser: isNew,
  });

  const {
    documentTypeIdSelected,
    identificationInput,
    isSearchLocked,
    associatedDoctorDocuments,
    associatedDoctorSpecialities,
    associatedDoctorSpecialitySelected,
    associatedDoctorSpecialityDocuments,
    associatedDoctorSpecialityOptions,
    isCedulaSelected,
    isAssociatedDoctorRequest,
    isSubmitting,
    isAddDisabled,
    loading,
    otherChannelConfirmation,
    isExistingUserWithoutMedical,
    CEDULA_DOCUMENT_TYPE_ID,
    PASAPORTE_DOCUMENT_TYPE_ID
  } = state;

  const {
    onChangeDocumentType,
    onAssociatedDoctorRequirementFileChange,
    onRemoveAssociatedDoctorDocument,
    onAssociatedDoctorSpecialitySelectedChange,
    onAddAssociatedDoctorSpeciality,
    onRemoveAssociatedDoctorSpeciality,
    onAssociatedDoctorSpecialityFileChange,
    onSearchUser,
    onResetModalSearch,
    clearAssociatedDoctorDocuments,
    getMedicalByBranch,
    validationAtLeastOneDoctor,
    validationAtleastOneDoctorActive,
    handleSubmit,
    setIdentificationInput
  } = actions;

  const entityName = isMedical === 2 ? "médico" : "usuario";
  const actionName = isNew ? "Agregar" : "Modificar";
  const nameHeader = `${actionName} ${entityName}`;
  const addSchedule = `${actionName} horario`;
  const profileOptions = useMemo(
    () =>
      filterProfilesByRecipeCapability(optionProfiles, isMedical === 2),
    [isMedical, optionProfiles],
  );

  const isLoadingData = loading && !isNew;

  return (
    <div className="animated fadeIn">
      <LoadingDhn isOpen={isSubmitting || isLoadingData} isDescription={false} />
      <Modal
        // className="modal-dialog"
        isOpen={isOpen && !isLoadingData}
        centered
        size={
          isAssociatedDoctorRequest || (!isNew && isMedical !== 1) ? "xl" : "lg"
        }
      >
        <ModalHeader
          toggle={
            isSubmitting
              ? undefined
              : () => {
                  clearAssociatedDoctorDocuments();
                  toggle(false);
                }
          }
          iconClass={isMedical === 2 ? "fa-user-md" : "fa-user"}
          description={nameHeader}
          subtitle="Complete los datos del usuario y su perfil en la sucursal."
        />

        <ModalBody>
          {(isNew || isMedical === 1) && (
            <Row form className="mb-2">
              {isNew && !isSearchLocked && (
                <>
                  <Col md={3}>
                    <Label>Tipo Documento:</Label>
                    <SelectableOptionGroup columns={2}>
                      <SelectableOption
                        key="document-type-cedula"
                        compact
                        icon="fa-id-card-o"
                        title="Cédula"
                        checked={isCedulaSelected}
                        onChange={() =>
                          onChangeDocumentType(CEDULA_DOCUMENT_TYPE_ID)
                        }
                      />
                      <SelectableOption
                        key="document-type-passport"
                        compact
                        icon="fa-book"
                        title="Pasaporte"
                        checked={
                          documentTypeIdSelected ===
                          PASAPORTE_DOCUMENT_TYPE_ID
                        }
                        onChange={() =>
                          onChangeDocumentType(PASAPORTE_DOCUMENT_TYPE_ID)
                        }
                      />
                    </SelectableOptionGroup>
                  </Col>
                  <Col md={5}>
                    <Label> No. de Indentificación: </Label>
                    {isCedulaSelected ? (
                      <ReactFormat
                        className="mr-2"
                        placeholder="Ingresar Número de Cédula"
                        customInput={Input}
                        disabled={!isNew}
                        format={"###-#######-#"}
                        value={identificationInput}
                        onValueChange={({ formattedValue }) => {
                          setIdentificationInput(formattedValue || "");
                        }}
                      />
                    ) : (
                      <Input
                        className="mr-2"
                        placeholder="Ingresar Número de Pasaporte"
                        disabled={!isNew}
                        value={identificationInput}
                        onChange={({ target: { value } }) =>
                          setIdentificationInput(value)
                        }
                      />
                    )}
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      color="primary"
                      className="ml-1 text-nowrap"
                      disabled={!isNew}
                      onClick={onSearchUser}
                    >
                      {loading ? (
                        <>
                          <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                          {" Cargando..."}
                        </>
                      ) : (
                        <>
                          <i className="fa fa-search" />
                          {" Buscar"}
                        </>
                      )}
                    </Button>
                  </Col>
                </>
              )}
              {dataUserSelected?.identification && !medicalSelected?.id && (
                <Col md={2}>
                  <Label>Es Medico:</Label>
                  <SelectableOptionGroup columns={1}>
                    <SelectableOption
                      key="is-medical-yes"
                      compact
                      icon="fa-user-md"
                      title="Si"
                      inputType="radio"
                      inputName="isMedical"
                      checked={isMedical === 2}
                      disabled={isExistingUserWithoutMedical}
                      description={
                        isExistingUserWithoutMedical
                          ? "Debe ser aprobado por DHN."
                          : undefined
                      }
                      onChange={({ target }) => {
                        onChange("profileSelected", null);
                        onChange(target.name, 2);
                        onChange("medicalSelected", {
                          identificationCard:
                            dataUserSelected?.identification,
                          documentTypeId: dataUserSelected?.documentTypeId,
                          username: dataUserSelected.username,
                          email: dataUserSelected.email,
                          firstName: dataUserSelected.firstName,
                          lastName: dataUserSelected.lastName,
                          profileId: null,
                          userId: dataUserSelected?.id,
                        });
                      }}
                    />
                    <SelectableOption
                      key="is-medical-no"
                      compact
                      icon="fa-user"
                      title="No"
                      inputType="radio"
                      inputName="isMedical"
                      checked={isMedical === 1}
                      onChange={({ target }) => {
                        clearAssociatedDoctorDocuments();
                        onChange("profileSelected", null);
                        onChange("profileId", null, "userSelected");
                        onChange("profile", null, "userSelected");
                        onChange(target.name, 1);
                      }}
                    />
                  </SelectableOptionGroup>
                </Col>
              )}
            </Row>
          )}
          {isMedical <= 1 ? (
            <User
              onChange={onChange}
              isMedical={isMedical}
              dataUserSelected={dataUserSelected}
              profileSelected={profileSelected}
              profileOptions={profileOptions}
              getMedicalByBranch={getMedicalByBranch}
              validationAtLeastOneDoctor={validationAtLeastOneDoctor}
              validationAtleastOneDoctorActive={
                validationAtleastOneDoctorActive
              }
              isNew={isNew}
            />
          ) : (
            <Medical
              isMedical={isMedical}
              onChange={onChange}
              medicalSelected={medicalSelected}
              profileOptions={profileOptions}
              profileSelected={profileSelected}
              schedulingFormat={schedulingFormat}
              addSchedule={addSchedule}
              scheduleSelected={scheduleSelected}
              isNew={isNew}
              documentTypeId={
                dataUserSelected?.documentTypeId || documentTypeIdSelected
              }
              isAssociatedDoctorRequest={isAssociatedDoctorRequest}
              associatedDoctorDocuments={associatedDoctorDocuments}
              associatedDoctorSpecialities={associatedDoctorSpecialities}
              associatedDoctorSpecialitySelected={associatedDoctorSpecialitySelected}
              associatedDoctorSpecialityDocuments={associatedDoctorSpecialityDocuments}
              associatedDoctorSpecialityOptions={associatedDoctorSpecialityOptions}
              onAssociatedDoctorRequirementFileChange={
                onAssociatedDoctorRequirementFileChange
              }
              onRemoveAssociatedDoctorDocument={
                onRemoveAssociatedDoctorDocument
              }
              onAssociatedDoctorSpecialitySelectedChange={onAssociatedDoctorSpecialitySelectedChange}
              onAddAssociatedDoctorSpeciality={onAddAssociatedDoctorSpeciality}
              onRemoveAssociatedDoctorSpeciality={onRemoveAssociatedDoctorSpeciality}
              onAssociatedDoctorSpecialityFileChange={onAssociatedDoctorSpecialityFileChange}
            />
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <div>
            <Button
              color={isAddDisabled ? "secondary" : "success"}
              className={`${isAddDisabled ? "" : "btn-color-success"} ml-1`}
              disabled={isAddDisabled}
              onClick={handleSubmit}
            >
              <i
                className={`fa ${
                  isSubmitting
                    ? "fa-spinner fa-spin"
                    : isNew
                      ? "fa-plus"
                      : "fa-check"
                }`}
              ></i>
              {isSubmitting
                ? " Guardando..."
                : isNew
                  ? " Agregar"
                  : " Modificar"}
            </Button>{" "}
            <Button
              color="danger"
              className="btn-color-danger"
              onClick={() => {
                clearAssociatedDoctorDocuments();
                toggle(false);
              }}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              {" Cancelar"}
            </Button>
          </div>
          {isNew && isSearchLocked && (
            <Button color="warning" onClick={onResetModalSearch}>
              <i className="fa fa-undo" aria-hidden="true"></i>
              {" Reiniciar formulario"}
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <UnsavedChangesModal
        isOpen={Boolean(otherChannelConfirmation)}
        title="Solicitud pendiente en otro canal"
        message={otherChannelConfirmation?.message}
        hint="¿Desea registrar una solicitud para este consultorio?"
        continueLabel="Cancelar"
        continueIcon="fa-times"
        discardLabel="Continuar con la solicitud"
        discardIcon="fa-check"
        onContinueEditing={actions.cancelOtherChannelSearch}
        onDiscard={actions.confirmOtherChannelSearch}
      />
    </div>
  );
}
